module.exports = __webpack_public_path__ + "img/kx1_mb.3f995aea.jpg";